import React, { useEffect, useState } from 'react';

import { ISCBWysiwyg } from 'types/interfaces/sulu/IContentBlocks';

import LinkPopup from './linkPopup';

const Wysiwyg = ({ content }: ISCBWysiwyg) => {
  const [processedContent, setProcessedContent] = useState<string>(content);

  useEffect(() => {
    let replacedContent = content;

    /**
     * WORKAROUND
     * replace keyword [TAB] with an unstyled list to get
     * the same indent as <ul> but without a bullet point
     */
    replacedContent = replacedContent.replaceAll(
      '<p>[TAB]',
      '<ul class="list-none"><li>',
    );
    replacedContent = replacedContent.replaceAll(
      /\[TAB\]([\s\S]*?)\[\/TAB\]/g,
      (match, innerContent) => `<ul class="list-none"><li>${innerContent}</li></ul>`,
    );

    /**
     * WORKAROUND
     * get the content between the keywords [ID] and [/ID] and
     * use this as the value for the attribute id on the
     * html element in which the keywords are located
     */
    const ids = [...replacedContent.matchAll(/\[ID\](.*?)\[\/ID\]/g)].map(res =>
      res.length > 1 ? res[1] : '',
    );
    let tempContentWithIds = replacedContent;
    ids.forEach(id => {
      const startIndexHtmlTag = tempContentWithIds.lastIndexOf(
        '<',
        tempContentWithIds.indexOf(id),
      );
      const endIndexHtmlTag = tempContentWithIds.lastIndexOf(
        '>',
        tempContentWithIds.indexOf(id),
      );
      const htmlTag = tempContentWithIds.substring(
        startIndexHtmlTag,
        endIndexHtmlTag,
      );
      const htmlTagWithId = `${htmlTag} id="${id}">`;

      tempContentWithIds = tempContentWithIds.replaceAll(`[ID]${id}[/ID]`, '');
      tempContentWithIds =
        tempContentWithIds.substring(0, startIndexHtmlTag) +
        htmlTagWithId +
        tempContentWithIds.substring(endIndexHtmlTag + 1);
    });
    replacedContent = tempContentWithIds;

    /**
     * WORKAROUND
     * find links or text between [HOVER] and [/HOVER] and display
     * a small popup when hovering over the text or link
     */
    replacedContent = replacedContent.replaceAll(
      /\[POPUP\](.*?)\[\/POPUP\]/g,
      innerContent => {
        const linkRegex = /<a\s+([^>]+)>(.*?)<\/a>/;
        const matchLink = innerContent.match(linkRegex);

        if (matchLink) {
          const linkAttributes = matchLink[1];
          const linkText = matchLink[2];
          const urlMatch = linkAttributes.match(/href="([^"]+)"/);
          const url = urlMatch ? urlMatch[1] : '';

          return `<a ${linkAttributes} class="hover-popup underline text-orange" data-popup="${url}" onclick="event.preventDefault();">${linkText}</a>`;
        }
        return innerContent;
      },
    );

    setProcessedContent(replacedContent);
  }, [content]); // Only depend on the initial content prop

  return (
    <>
      {/* eslint-disable-next-line react/no-danger */}
      <LinkPopup />
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: processedContent }} />
    </>
  );
};

export default Wysiwyg;
